import routerOptions0 from "/builds/nordhealth/projects/veterinary/provet-cloud/provet-cloud-frontend/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@22.19.7_@vue+compiler-sfc@3.5.26_cac@6.7._98eb7543b9d391d63c2625026cbca986/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/nordhealth/projects/veterinary/provet-cloud/provet-cloud-frontend/app/router.options.ts";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? true
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}